
export const HOME_PATH = "/staging";

export const categories = [
  {
    "id": 2100,
    "parent_id": 0,
    "name": "Pet Insurance Brochures",
    "url": null,
    "description": null,
    "products": [
      {
        "id": 160647,
        "name": "Nationwide Brochure Dog (A)",
        "additional_info": "Brochure about Nationwide pet insurance with plan details. Perfect for use in puppy kits, new client kits, and handing out to clients."
      },
      {
        "id": 160662,
        "name": "Nationwide Brochure Dog (B)",
        "additional_info": "Brochure about Nationwide pet insurance without plan details. Perfect for use in puppy kits, new client kits, and handing out to clients."
      },
      {
        "id": 160648,
        "name": "Nationwide Brochure Cat (A)",
        "additional_info": "Brochure about Nationwide pet insurance with plan details. Perfect for use in kitten kits, new client kits, and handing out to clients."
      },
      {
        "id": 160663,
        "name": "Nationwide Brochure Cat (B)",
        "additional_info": "Brochure about Nationwide pet insurance with plan details. Perfect for use in kitten kits, new client kits, and handing out to clients."
      },
      {
        "id": 142624,
        "name": "Nationwide Brochure Avian & Exotic ",
        "additional_info": "Brochure about Nationwide pet insurance with adorable photos of birds, reptiles, and small mammals. Perfect for use in new client kits and handing out to clients."
      }
    ]
  },
  {
    "id": 2362,
    "parent_id": 0,
    "name": "Guides",
    "url": null,
    "description": null,
    "products": [
      {
        "id": 160664,
        "name": "Nationwide New Puppy Guide",
        "additional_info": "Pet education guide about the basics of caring for a new puppy. Perfect for use in puppy kits, new client kits, and handing out to clients."
      },
      {
        "id": 160665,
        "name": "Nationwide New Kitten Guide",
        "additional_info": "Pet education guide about the basics of caring for a new kitten. Perfect for use in kitten kits, new client kits, and handing out to clients."
      },
      {
        "id": 160830,
        "name": "Nationwide Pet Insurance Guide for Veterinary Practices",
        "additional_info": "Staff education guide about the basics of Nationwide pet insurance. Perfect for introducing Nationwide pet insurance to veterinary healthcare teams."
      }
    ]
  },
  {
    "id": 2214,
    "parent_id": 0,
    "name": "Pet HealthZone",
    "url": null,
    "description": null,
    "products": [
      {
        "id": 149590,
        "name": "Nationwide Pet HealthZone for Cats",
        "additional_info": "Client handout about using the Nationwide Pet HealthZone to learn about caring for their cat. Perfect for use in kitten kits, new client kits, and handing out to clients."
      },
      {
        "id": 149589,
        "name": "Nationwide Pet HealthZone for Dogs",
        "additional_info": "Client handout about using the Nationwide Pet HealthZone to learn about caring for their dog. Perfect for use in puppy kits, new client kits, and handing out to clients."
      },
      {
        "id": 144058,
        "name": "Pet HealthZone Easelback for display",
        "additional_info": "Easelback for display with information about the Pet HealthZone and QR code for easy access (8.5\" x 11\"). \n",
      },
      {
        "id": 144060,
        "name": "Pet HealthZone Flyer for Vet Teams",
        "additional_info": "Flyer for veterinary healthcare teams, describing the Pet HealthZone and how it can help your clients understand the health concerns for their specific pet. Not for client distribution. (8.5\" x 11\")",
      },
      {
        "id": 145741,
        "name": "Pet HealthZone Poster for display",
        "additional_info": "Poster for display in clinic to direct clients to the Pet HealthZone. (11\" x 17\")"
      },
      {
        "id": 144048,
        "name": "Top 10 Canine Health Conditions",
        "additional_info": "Pet education brochure about the most frequently occurring medical conditions in dogs. Perfect for use in puppy kits, new client kits, and handing out to clients. Includes QR code for easy access to the Pet HealthZone."
      }
    ]
  }
];